import { TryAndBuy } from "./TryAndBuy";

export default TryAndBuy;
